export default __webpack_public_path__ + "static/media/no-no-no.64c7bc26.gif";